export default __webpack_public_path__ + "static/media/05A.090.a6dcdd18.png";